<template>
<vue-picture :imgset="imgset" :sizes="matchedSizes" :className="classNames"></vue-picture>
</template>
<script>

import VuePicture from './VuePicture.vue';

export default {
  props: {
    imgset: {},
    sizes: {},
    aspect: {
      type: String,
      default: 'natural'
    },
    className: ''
  },
  data: function() {
    return {
      matchedSizes: {},
      defaultSize: 'max_720x720',
      classNames: []
    }
  },
  created: function() {
    this.classNames = [this.imgset.attributes.className, this.aspect]
    switch (this.aspect) {
      case 'portrait-fixed':
        this.matchedSizes = this.sizes.portrait
        break;
      case 'landscape-fixed':
        this.matchedSizes = this.sizes.landscape
        break;
      default:
        this.matchedSizes = this.sizes.full
        break;
    }
  },
  components: {
    VuePicture
  }
}
</script>


// WEBPACK FOOTER //
// VueFlexpic.vue?5983126c